import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import DeleteButton from './DeleteButton';
const styles = (styles) => css `
  position: relative;

  .delete {
    position: absolute;
    top: 2px;
    left: 2px;
  }

  ${styles}
`;
export default function Tab({ tabid, title, isActive, onClick = () => null, canDelete, onDelete = () => null, tabstyles, render, className, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
children, }) {
    const classNames = ['tab-list-item'];
    // use tab identifier if given (higher priority)
    if (isActive) {
        classNames.push('tab-list-active');
    }
    function clickHandler(e) {
        onClick({ ...e, title, tabid });
    }
    function deleteHandler(e) {
        // stop propagation here to not have set it
        // as active tab too (via tab click event triggering)
        e.stopPropagation();
        onDelete({ ...e, title, tabid });
    }
    return (_jsxs("li", { className: `${classNames.join(' ')} ${className || ''}`, onClick: clickHandler, css: styles(tabstyles), children: [canDelete && _jsx(DeleteButton, { onDelete: deleteHandler }), render
                ? render({ isActive: isActive || false, title: title || '', tabid })
                : title] }));
}
